/* @generated */
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var props = __getOwnPropSymbols(b), i = 0, n = props.length, prop; i < n; i++) {
      prop = props[i];
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = function(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function(target, all) {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = function(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function")
    for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
      key = keys[i];
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: function(k) {
          return from[k];
        }.bind(null, key), enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
  return to;
};
var __toESM = function(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  );
};
var __toCommonJS = function(mod) {
  return __copyProps(__defProp({}, "__esModule", { value: true }), mod);
};

// ../src/progress_indicators/index.ts
var progress_indicators_exports = {};
__export(progress_indicators_exports, {
  Interstitial: function() {
    return Interstitial;
  },
  ProgressBar: function() {
    return ProgressBar;
  },
  Spinner: function() {
    return Spinner;
  }
});
module.exports = __toCommonJS(progress_indicators_exports);

// ../src/progress_indicators/interstitial/interstitial.tsx
var import_dig_foundations = require("@dropbox/dig-foundations");
var import_classnames = __toESM(require("classnames"));
var React = __toESM(require("react"));
var import_react_transition_group = require("react-transition-group");

// ../src/progress_indicators/interstitial/index.css.ts
var import_createRuntimeFn = require("@vanilla-extract/recipes/createRuntimeFn");
var interstitialCssTransitionStyle = "dig-umnl38a_21-1-1";
var interstitialDotOneStyle = "dig-umnl38b_21-1-1";
var interstitialDotStyle = "dig-umnl389_21-1-1";
var interstitialDotTwoStyle = "dig-umnl38c_21-1-1";
var interstitialInnerStyle = "dig-umnl388_21-1-1";
var interstitialRecipe = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-umnl386_21-1-1", variantClassNames: { complete: { true: "dig-umnl387_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var interstitialTrackStyle = "dig-umnl385_21-1-1";

// ../src/progress_indicators/interstitial/interstitial.tsx
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["className", "onComplete", "value", "isIndeterminate", "inverse", "aria-valuetext"];
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var STARTING_OFFSET = 800;
var END_OFFSET = 100;
var OFFSET_DIFF = STARTING_OFFSET - END_OFFSET;
var Interstitial = function(_ref) {
  var className = _ref.className, onComplete = _ref.onComplete, _ref$value = _ref.value, value = _ref$value === void 0 ? 0 : _ref$value, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, _ref$inverse = _ref.inverse, inverse = _ref$inverse === void 0 ? false : _ref$inverse, ariaValueText = _ref["aria-valuetext"], rest = _objectWithoutProperties(_ref, _excluded);
  var clampedValue = Math.min(100, Math.max(0, value));
  var inverseClassName = (0, import_dig_foundations.useTheme)().getInverseProps().className;
  var ref = React.useRef(null);
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), complete = _React$useState2[0], setComplete = _React$useState2[1];
  var trackRectRef = React.useRef(null);
  var cls = (0, import_classnames.default)("dig-Interstitial", interstitialRecipe({
    complete: complete
  }), _defineProperty({
    "dig-Interstitial--isIndeterminate": isIndeterminate,
    "dig-Interstitial--complete": complete
  }, inverseClassName, inverse), className);
  var a11yProps = {};
  if (isIndeterminate) {
    a11yProps["aria-valuetext"] = ariaValueText;
  } else {
    a11yProps["aria-valuenow"] = clampedValue;
    a11yProps["aria-valuemin"] = 0;
    a11yProps["aria-valuemax"] = 100;
  }
  var timeout2 = {
    exit: 1e3
  };
  var handleTransitionEnd = function(evt) {
    if (!ref || ref.current !== evt.target)
      return;
    if (complete && onComplete) {
      onComplete();
      setComplete(false);
    }
  };
  React.useEffect(function() {
    if (value >= 100 && !complete) {
      setComplete(true);
    }
    var updateTrack = function() {
      var offset = Math.max(STARTING_OFFSET - clampedValue / 100 * OFFSET_DIFF, 0);
      if (trackRectRef && trackRectRef.current) {
        trackRectRef.current.setAttribute("stroke-dashoffset", offset.toString());
      }
    };
    updateTrack();
  }, [value, complete, clampedValue, trackRectRef]);
  return /* @__PURE__ */ React.createElement(
    import_react_transition_group.CSSTransition,
    __spreadValues({
      timeout: timeout2,
      classNames: (0, import_classnames.default)("dig-Interstitial-container", interstitialCssTransitionStyle),
      unmountOnExit: true
    }, rest),
    /* @__PURE__ */ React.createElement("div", __spreadProps(__spreadValues({ role: "progressbar" }, a11yProps), { className: cls, onTransitionEnd: handleTransitionEnd, ref: ref }), /* @__PURE__ */ React.createElement("div", { className: (0, import_classnames.default)("dig-Interstitial-inner", interstitialInnerStyle) }, !isIndeterminate && /* @__PURE__ */ React.createElement("svg", { className: (0, import_classnames.default)("dig-Interstitial-track", interstitialTrackStyle), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 300 300", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ React.createElement("rect", { fill: "none", stroke: "currentColor", strokeLinecap: "square", strokeWidth: "100", x: "50", y: "50", width: "200", height: "200", ref: trackRectRef })), /* @__PURE__ */ React.createElement("div", { className: (0, import_classnames.default)("dig-Interstitial-dot", "dig-Interstitial-dot--one", interstitialDotStyle, interstitialDotOneStyle) }), /* @__PURE__ */ React.createElement("div", { className: (0, import_classnames.default)("dig-Interstitial-dot", "dig-Interstitial-dot--two", interstitialDotStyle, interstitialDotTwoStyle) })))
  );
};
Interstitial.displayName = "Interstitial";

// ../src/progress_indicators/progress_bar/progress_bar.tsx
var React2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var import_react_transition_group2 = require("react-transition-group");
var import_dig_foundations2 = require("@dropbox/dig-foundations");

// ../src/progress_indicators/progress_bar/index.css.ts
var import_createRuntimeFn2 = require("@vanilla-extract/recipes/createRuntimeFn");
var progressBarCompleteStyle = "dig-uq0kcze_21-1-1";
var progressBarContainerRecipe = (0, import_createRuntimeFn2.createRuntimeFn)({ defaultClassName: "dig-uq0kcz6_21-1-1", variantClassNames: { isStatic: { true: "dig-uq0kcz7_21-1-1", false: "dig-uq0kcz8_21-1-1" }, isIndeterminate: { true: "dig-uq0kcz9_21-1-1", false: "dig-uq0kcza_21-1-1", undefined: "dig-uq0kczb_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var progressBarTrackInnerStyle = "dig-uq0kczd_21-1-1";
var progressBarTrackStyle = "dig-uq0kczc_21-1-1";

// ../src/progress_indicators/progress_bar/progress_bar.tsx
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var _excluded2 = ["showInner", "className"];
var _excluded22 = ["className", "value", "inverse", "isStatic"];
var _excluded3 = ["isIndeterminate", "onComplete", "aria-valuetext"];
function _defineProperty2(obj, key, value) {
  key = _toPropertyKey2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == _typeof2(i) ? i : String(i);
}
function _toPrimitive2(t, r) {
  if ("object" != _typeof2(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof2(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var timeout = {
  exit: 1e3
};
var getAriaProps = function(value) {
  return {
    "aria-valuenow": value,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  };
};
var ProgressBarTrack = function(_ref) {
  var showInner = _ref.showInner, className = _ref.className, rest = _objectWithoutProperties2(_ref, _excluded2);
  return /* @__PURE__ */ React2.createElement("div", __spreadProps(__spreadValues({}, rest), { className: (0, import_classnames2.default)(className, "dig-ProgressBar-track", progressBarTrackStyle) }), showInner && /* @__PURE__ */ React2.createElement("div", { className: (0, import_classnames2.default)("dig-ProgressBar-track-inner", progressBarTrackInnerStyle) }));
};
var ProgressBar = function(_ref2) {
  var className = _ref2.className, _ref2$value = _ref2.value, value = _ref2$value === void 0 ? 0 : _ref2$value, _ref2$inverse = _ref2.inverse, inverse = _ref2$inverse === void 0 ? false : _ref2$inverse, isStatic = _ref2.isStatic, rest = _objectWithoutProperties2(_ref2, _excluded22);
  var scale = Math.min(1, Math.max(0, value / 100));
  var inverseClassName = (0, import_dig_foundations2.useTheme)().getInverseProps().className;
  if (isStatic) {
    var _cls = (0, import_classnames2.default)("dig-ProgressBar-container", "dig-ProgressBar--static", progressBarContainerRecipe({
      isStatic: true
    }), className, _defineProperty2({}, inverseClassName, inverse));
    var _trackStyle = {
      transform: "scaleX(".concat(scale, ")")
    };
    var _a11yProps = getAriaProps(value);
    return /* @__PURE__ */ React2.createElement("div", __spreadValues(__spreadProps(__spreadValues({ role: "progressbar" }, _a11yProps), { className: _cls }), rest), /* @__PURE__ */ React2.createElement(ProgressBarTrack, { style: _trackStyle }));
  }
  var isIndeterminate = rest.isIndeterminate, onComplete = rest.onComplete, ariaValueText = rest["aria-valuetext"], restDynamic = _objectWithoutProperties2(rest, _excluded3);
  var trackStyle = {};
  var a11yProps = {};
  var cls = (0, import_classnames2.default)("dig-ProgressBar-container", progressBarContainerRecipe({
    isStatic: false,
    isIndeterminate: !!isIndeterminate
  }), className, {
    "dig-ProgressBar--determinate": !isIndeterminate,
    "dig-ProgressBar--indeterminate": isIndeterminate,
    "dig-ProgressBar--inverse": inverse
  });
  if (isIndeterminate) {
    a11yProps["aria-valuetext"] = ariaValueText;
  } else {
    trackStyle.transform = "scaleX(".concat(scale, ")");
    a11yProps = getAriaProps(value);
  }
  var trackIterate = function(evt) {
    if (value >= 100 && (evt.animationName === "progressBarIndeterminateTranslate" || !isIndeterminate)) {
      if (onComplete)
        onComplete();
    }
  };
  return /* @__PURE__ */ React2.createElement(
    import_react_transition_group2.CSSTransition,
    __spreadValues({
      timeout: timeout,
      classNames: (0, import_classnames2.default)("dig-ProgressBar-container", progressBarContainerRecipe({
        isStatic: false,
        isIndeterminate: void 0
      })),
      unmountOnExit: true
    }, restDynamic),
    /* @__PURE__ */ React2.createElement("div", __spreadProps(__spreadValues({ role: "progressbar" }, a11yProps), { className: cls }), /* @__PURE__ */ React2.createElement(ProgressBarTrack, { style: trackStyle, onAnimationIteration: trackIterate, showInner: !isIndeterminate }), /* @__PURE__ */ React2.createElement("div", { className: (0, import_classnames2.default)("dig-ProgressBar-complete", progressBarCompleteStyle) }))
  );
};
ProgressBar.displayName = "ProgressBar";

// ../src/progress_indicators/spinner/spinner.tsx
var import_classnames3 = __toESM(require("classnames"));
var React3 = __toESM(require("react"));

// ../src/_global/sizes.tsx
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getLegacyComponentSize = function(size) {
  var mapping = deprecationMap.find(function(_ref) {
    var _ref2 = _slicedToArray2(_ref, 2), newVal = _ref2[0], _deprecatedVal = _ref2[1];
    return size === newVal;
  });
  if (mapping !== void 0) {
    return mapping[1];
  }
  return size;
};
var getMigratedComponentSize = function(size) {
  var mapping = deprecationMap.find(function(_ref3) {
    var _ref4 = _slicedToArray2(_ref3, 2), _newVal = _ref4[0], deprecatedVal = _ref4[1];
    return size === deprecatedVal;
  });
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/progress_indicators/spinner/spinner.tsx
var import_dig_foundations3 = require("@dropbox/dig-foundations");

// ../src/progress_indicators/spinner/index.css.ts
var import_createRuntimeFn3 = require("@vanilla-extract/recipes/createRuntimeFn");
var spinnerContentRecipe = (0, import_createRuntimeFn3.createRuntimeFn)({ defaultClassName: "dig-q8afrb8_21-1-1", variantClassNames: { size: { xsmall: "dig-q8afrb9_21-1-1", small: "dig-q8afrba_21-1-1", medium: "dig-q8afrbb_21-1-1", large: "dig-q8afrbc_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var spinnerDotRecipe = (0, import_createRuntimeFn3.createRuntimeFn)({ defaultClassName: "dig-q8afrbe_21-1-1", variantClassNames: { location: { one: "dig-q8afrbf_21-1-1", two: "dig-q8afrbg_21-1-1" }, monochromatic: { true: "dig-q8afrbh_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var spinnerRecipe = (0, import_createRuntimeFn3.createRuntimeFn)({ defaultClassName: "dig-q8afrb2_21-1-1", variantClassNames: { size: { xsmall: "dig-q8afrb3_21-1-1", small: "dig-q8afrb4_21-1-1", medium: "dig-q8afrb5_21-1-1", large: "dig-q8afrb6_21-1-1" }, hasOpaqueTrack: { true: "dig-q8afrb7_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var spinnerTrackStyle = "dig-q8afrbd_21-1-1";

// ../src/progress_indicators/spinner/spinner.tsx
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
var _excluded4 = ["aria-valuetext", "className", "withTrack", "inverse", "size", "monochromatic", "hasOpaqueTrack"];
function _defineProperty3(obj, key, value) {
  key = _toPropertyKey3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey3(t) {
  var i = _toPrimitive3(t, "string");
  return "symbol" == _typeof3(i) ? i : String(i);
}
function _toPrimitive3(t, r) {
  if ("object" != _typeof3(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof3(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var TrackSVG = function() {
  return /* @__PURE__ */ React3.createElement("svg", { className: (0, import_classnames3.default)("dig-Spinner--track", spinnerTrackStyle), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", "data-testid": "digSpinnerTrack" }, /* @__PURE__ */ React3.createElement("rect", { fill: "none", strokeLinecap: "square", strokeWidth: "6", x: "3", y: "3", width: "18", height: "18" }));
};
var Spinner = function(_ref) {
  var ariaValueText = _ref["aria-valuetext"], className = _ref.className, _ref$withTrack = _ref.withTrack, withTrack = _ref$withTrack === void 0 ? true : _ref$withTrack, inverse = _ref.inverse, _ref$size = _ref.size, _size = _ref$size === void 0 ? "medium" : _ref$size, _ref$monochromatic = _ref.monochromatic, monochromatic = _ref$monochromatic === void 0 ? false : _ref$monochromatic, _ref$hasOpaqueTrack = _ref.hasOpaqueTrack, hasOpaqueTrack = _ref$hasOpaqueTrack === void 0 ? false : _ref$hasOpaqueTrack, rest = _objectWithoutProperties3(_ref, _excluded4);
  var size = getMigratedComponentSize(_size);
  var inverseClassName = (0, import_dig_foundations3.useTheme)().getInverseProps().className;
  return /* @__PURE__ */ React3.createElement("div", __spreadValues({ role: "progressbar", "aria-valuetext": ariaValueText, className: (0, import_classnames3.default)("dig-Spinner", className, spinnerRecipe({
    hasOpaqueTrack: hasOpaqueTrack,
    size: size
  }), "dig-Spinner--".concat(getLegacyComponentSize(size)), _defineProperty3(_defineProperty3(_defineProperty3({
    "dig-Spinner--medium": size === "medium"
  }, inverseClassName, inverse), "dig-Spinner--monochromatic", monochromatic), "dig-Spinner--hasOpaqueTrack", hasOpaqueTrack)) }, rest), /* @__PURE__ */ React3.createElement("div", { className: (0, import_classnames3.default)("dig-Spinner-content", spinnerContentRecipe({
    size: size
  })) }, withTrack && /* @__PURE__ */ React3.createElement(TrackSVG, null), /* @__PURE__ */ React3.createElement("div", { className: (0, import_classnames3.default)("dig-Spinner-dot", "dig-Spinner-dot--one", spinnerDotRecipe({
    location: "one",
    monochromatic: monochromatic
  })) }), /* @__PURE__ */ React3.createElement("div", { className: (0, import_classnames3.default)("dig-Spinner-dot", "dig-Spinner-dot--two", spinnerDotRecipe({
    location: "two",
    monochromatic: monochromatic
  })) })));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Interstitial,
  ProgressBar,
  Spinner
});
